import React from 'react';

import { useTranslation } from 'react-i18next';

import { ArrowIcon } from '@pkg/assets/floorGame';
import { Chip, ChipColor, ChipSize } from '@pkg/components/Sections/Profile/Chip';

import { GainsArrow, GainsLabel, GainsText, GainsValue, StyledGainsChip } from './styles';

export interface GainsChipProps {
    percentage?: number;
    compact?: boolean;
}

export function GainsChip({ percentage = 0, compact = false }: GainsChipProps) {
    const { t: translate } = useTranslation('floorgame');

    // TODO: What should we consider a `0` value?
    // Should we show a difference icon instead of an `arrow`?
    const isNegative = Math.sign(percentage) === -1;
    const forcedPositiveValue = Math.abs(percentage);

    const label = isNegative ? translate('nft_worth_loss_label') : translate('nft_worth_gains_label');

    const labelMarkup = compact ? null : (
        <GainsLabel>
            <GainsText>{label}</GainsText>
        </GainsLabel>
    );

    const i18nValueArg = { percentage: forcedPositiveValue };

    const value = isNegative
        ? translate('nft_worth_loss_value', i18nValueArg)
        : translate('nft_worth_gains_value', i18nValueArg);

    return (
        <StyledGainsChip>
            <Chip color={ChipColor.BlurDark} size={compact ? ChipSize.Smaller : ChipSize.Small}>
                <Chip.Interior>
                    {labelMarkup}

                    <GainsValue>
                        <GainsArrow $loss={isNegative}>
                            <ArrowIcon />
                        </GainsArrow>

                        <GainsText>{value}</GainsText>
                    </GainsValue>
                </Chip.Interior>
            </Chip>
        </StyledGainsChip>
    );
}
